function MainBody() {
    return (
        <div>
            <img src="/logo.png" alt="logo" width={"168px"} style={{marginTop: "28px"}}/>
        </div>
    );
}

export default MainBody;